// Tickets-related root state. Merged into consumer apps' state via the
// sharedLibraries pipeline. Keep keys camelCase + scoped with `ticket*` or
// `_ticket*` prefixes so they're easy to grep from page/component code.

export default {
  tickets: [],
  myTickets: [],
  columns: [],
  totalByColumn: {},
  // The sidebar TYPE filter's per-bucket counts ({ all, bug, task,
  // user_story }), written with totalByColumn by the board's load wave and
  // its count refreshes — see fetchTypeCounts in functions/ticketLoaders.js.
  totalByType: {},
  // The /tickets board's status: true while the board page is mounted, so its
  // counts are on screen. The board's onCreate / onRemove write it; the
  // registered counts refresh (functions/ticketLoaders.js
  // refreshTicketsCounts) reads nothing while it is false.
  _ticketsBoardLive: false,
  loadedByColumn: {},
  loadingColumn: {},
  selectedTicket: null,
  // Off-canvas filters sheet (phones only — the shared MobileRailSheet on
  // /tickets/board + /tickets/epics). Ephemeral UI, never persisted: the sheet,
  // its bottom-left FAB and the left-edge pull (armEdgeSwipe) all read and
  // write this ONE key, so they can never disagree about the open state.
  // Declared here so it exists at cold boot for subscribeTo to bind to.
  _ticketsRailOpen: false,
  searchQuery: '',
  // Unsent ticket-comment composer text, keyed by ticket id — survives an
  // Esc-close of the detail modal within the same SPA session (TASKS-MICRO-1b:
  // Esc used to drop typed-but-unsent comment text with no warning at all).
  // Explicitly in-memory-only, not persisted across a hard reload.
  _commentDrafts: {},
  // In-flight optimistic ticket creates, keyed by their temp client id —
  // lets the board's realtime INSERT handler correlate a server echo back to
  // the row THIS client just created (temp id vs the server's real id are
  // different values for the same logical ticket until the create promise
  // resolves). See TASKS-DUPE-RENDER-1 in pages/board.js + TicketDetailModal.js.
  _pendingTicketCreates: [],
  filterAssignee: 'all',
  filterEpic: null,
  filterIssueType: null,
  filterLabel: null,
  // The board's project scope — /tasks?project=<id> (the task↔project link;
  // an AI answer's ↗ Open carries it). Read on the board's mount, cleared on
  // its unmount (pages/board.js), as the ?cycle= scope is.
  filterProjectId: null,
  // Epic-TYPE ticket rows (type:'epic'), lazy-loaded by loadEpicsTree (see
  // ticketLoaders.js) and shared by the sidebar EPIC filter, the ticket
  // modal's Epic select, and the Manage Epics modal below — ONE cache, three
  // readers, so they can never disagree about which epics exist. null while
  // never fetched this session, [] once fetched with zero rows. Was already
  // written via root.update() before this declaration existed (the signal
  // store auto-vivifies new keys on first write — see
  // smbls/packages/signal/src/store.js `set()` "New property" branch — so
  // this key was never actually silently dropped); declared here to match
  // the `cycles: null` sibling pattern and document the contract.
  epicsTree: null,
  // Manage Epics modal (2026-08-02 per Nika "add option (manage epics) …
  // modal opens to manage epics (crud)") — opened from the tickets/board "+"
  // create dropdown (ticketsCreateRows). Truthy = open. CRUD operates on
  // epic-TYPE tickets via the existing saveTicket/deleteTicket functions;
  // every mutation reloads epicsTree so the filter + modal picker update
  // without a reload.
  epicsManage: null,
  epicsManageLoading: false,
  epicsManagePending: false,
  epicsManageError: null,
  epicsManageDraft: '', // new-epic name input
  epicsManageEditId: null, // id of the row currently in inline-rename mode
  epicsManageEditDraft: '', // inline rename input value
  epicsManageCounts: {}, // { [epicTitle]: { total, byColumn } } — from fetchEpicCounts
  // Roadmap cycles — populated by /tickets/roadmap onCreate via
  // sdk.tickets.cycle.list. null while loading, [] once loaded with no
  // cycles, array of cycle DTOs otherwise.
  cycles: null,
  // Per-cycle ticket caches keyed by cycle._id. Populated lazily when a
  // cycle card expands.
  cycleTicketsById: {},
  // Form modal state — `cycleEdit` opens the create/edit modal.
  // `null` = closed, `{ mode: 'create' }` = new, `{ mode: 'edit', id }` = edit.
  cycleEdit: null,
  cycleEditDraft: { name: '', description: '', startsAt: '', endsAt: '' },
  cycleEditPending: false,
  cycleEditError: null,
  // Attach-ticket modal — opens when manager clicks "Add ticket" inside a
  // cycle card. Holds the target cycle id + draft ticketId input.
  cycleAttach: null,
  cycleAttachDraft: '',
  cycleAttachPending: false,
  cycleAttachError: null
}
